import { isEmpty } from 'ramda';

// getMiddleText retourne la clé elle-même quand elle est absente du CMS.
// Cette fonction protège contre ce cas, contre les valeurs non-string (ex : booléen pour un champ
// déclaré `type => 'boolean'` dans le CMS) et contre les chaînes vides ou de blancs.
export const sanitizeCmsText = (value, key, fallback) => {
  if (typeof value !== 'string' || isEmpty(value.trim()) || value === key) {
    return fallback;
  }

  return value;
};
